// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorItem_content__tJF3p"};